import requestAction from '../../utils/requestAction'
import { NonSchoolDayInput } from '../../models/NonSchoolDay';

export const bulkUpsertDays = (records: NonSchoolDayInput[]) =>
  requestAction('NON_SCHOOL_DAY_BULK_UPSERT')('non-school-days/bulk', 'POST', { records })
